// src/components/atoms/VideoVolumeControl.js

import React from "react";
import { IconButton, Slider } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const VideoVolumeControl = ({ volume, onVolumeChange }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <IconButton aria-label="Volume">
        {volume > 0 ? (
          <VolumeUpIcon sx={{ color: "white" }} />
        ) : (
          <VolumeOffIcon sx={{ color: "white" }} />
        )}
      </IconButton>
      <Slider
        value={volume}
        onChange={onVolumeChange}
        aria-labelledby="volume-slider"
        min={0}
        max={1}
        step={0.01}
        style={{ width: 100, color: "white" }}
      />
    </div>
  );
};

export default VideoVolumeControl;
